import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { api } from '@/lib/api';
import { Mail } from 'lucide-react';
import { useNoIndex } from '@/hooks/useSEO';

export default function ForgotPassword() {
    useNoIndex('Reset password — Linguistic Quest');
    const [email, setEmail] = useState('');
    const [busy, setBusy] = useState(false);
    const [sent, setSent] = useState(false);
    const [err, setErr] = useState(null);

    const submit = async (e) => {
        e.preventDefault();
        setBusy(true); setErr(null);
        try {
            await api.post('/auth/forgot-password', { email });
            setSent(true);
        } catch (e) {
            setErr('Could not send right now — please try again in a minute.');
        } finally { setBusy(false); }
    };

    return (
        <main className="max-w-md mx-auto px-6 py-16" data-testid="page-forgot-password">
            <div className="flex justify-center"><Mail size={32} className="text-lq-purple-500"/></div>
            <h1 className="mt-4 font-display text-3xl font-semibold text-lq-ink-black text-center">Forgot your password?</h1>
            <p className="mt-2 text-lq-ink-700 text-center">Pop in your email and we'll send you a reset link. It will work for 60 minutes.</p>

            {sent ? (
                <div className="mt-8 bg-lq-peach-100 border border-lq-peach-300 rounded-2xl p-5 text-center" data-testid="forgot-password-sent">
                    <p className="text-lq-ink-900">If <strong>{email}</strong> is on our list, a reset link is on its way. Check your spam folder if it doesn't arrive in a minute.</p>
                    <Link to="/login" className="mt-4 inline-block text-lq-purple-700 font-semibold hover:underline">Back to sign in</Link>
                </div>
            ) : (
                <form onSubmit={submit} className="mt-8 space-y-4" data-testid="forgot-password-form">
                    <label className="block">
                        <span className="text-sm font-medium text-lq-ink-900">Email</span>
                        <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
                            className="mt-1 w-full px-4 py-3 rounded-xl border border-lq-ink-300 bg-white focus:border-lq-purple-500 outline-none"
                            data-testid="forgot-password-email" />
                    </label>
                    {err && <p className="text-sm text-lq-error">{err}</p>}
                    <button type="submit" disabled={busy} className="w-full py-3 rounded-full bg-lq-purple-500 hover:bg-lq-purple-700 text-white font-semibold disabled:opacity-60" data-testid="forgot-password-submit">
                        {busy ? 'Sending…' : 'Send reset link'}
                    </button>
                    <p className="text-sm text-center text-lq-ink-500">
                        Remember it now? <Link to="/login" className="text-lq-purple-700 hover:underline">Sign in</Link>
                    </p>
                </form>
            )}
        </main>
    );
}
